import { DONE, FAILED, START } from "../../constants";
import { getAxiosInstance } from "../common";
import { login_done } from "../actions";

export const FETCH_MY = "FETCH_MY";
export const UPDATE_MY = "UPDATE_MY";
export const UPDATE_MY_BILLING_DATA = "UPDATE_MY_BILLING_DATA";
export const UPDATE_MY_ADDRESS_DATA = "UPDATE_MY_ADDRESS_DATA";
export const REMOVE_ACCOUNT = "REMOVE_ACCOUNT";
export const AFTER_FIRST_LOGIN = "AFTER_FIRST_LOGIN";

export const fetchMyProfile = () => async (dispatch) => {
  dispatch({ type: FETCH_MY + START });
  try {
    const result = await getAxiosInstance().get(`/api/persons/my`);
    dispatch({ type: FETCH_MY + DONE, payload: result.data });

    return result;
  } catch (payload) {
    dispatch({ type: FETCH_MY + FAILED, payload });
    return false;
  }
};

export const removeMyAccountRequest = () => async (dispatch) => {
  dispatch({ type: REMOVE_ACCOUNT + START });
  try {
    const result = await getAxiosInstance().post(
      `/api/persons/my/request-account-remove`
    );
    dispatch({ type: REMOVE_ACCOUNT + DONE, payload: result.data });

    return result;
  } catch (payload) {
    dispatch({ type: REMOVE_ACCOUNT + FAILED, payload });
    return payload.response;
  }
};

export const updateMyProfile = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_MY + START });
  try {
    const result = await getAxiosInstance().put(`/api/persons/my`, payload);
    dispatch({ type: UPDATE_MY + DONE, payload: result.data });

    return result;
  } catch (payload) {
    dispatch({ type: UPDATE_MY + FAILED, payload });
    return payload.response;
  }
};

export const updateMyProfileExt = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_MY + START });
  try {
    const { avatarImage, ...properties } = payload;

    const formData = new FormData();
    formData.append("avatarImage", avatarImage);
    formData.append(
      "properties",
      new Blob([JSON.stringify(properties)], {
        type: "application/json",
      })
    );

    const result = await getAxiosInstance().put(`/api/persons/ext`, formData);
    dispatch({ type: UPDATE_MY + DONE, payload: result.data });

    return result;
  } catch (payload) {
    dispatch({ type: UPDATE_MY + FAILED, payload });
    return payload.response;
  }
};

export const changeMyPassword = (payload) => async (dispatch) => {
  try {
    const result = await getAxiosInstance().put(
      `/api/auth/change_password`,
      payload
    );

    const my = await getAxiosInstance().get("/api/persons/my");

    dispatch(
      login_done({
        data: result.data,
        my: my.data,
      })
    );

    return result.data;
  } catch (payload) {
    return false;
  }
};

export const setFirstLoginToFalse = () => async (dispatch) => {
  try {
    const result = await getAxiosInstance().put(
      "/api/persons/after_first_login"
    );
    dispatch({ type: AFTER_FIRST_LOGIN + DONE });

    return result;
  } catch (e) {
    return false;
  }
};

export const updateMyBillingData = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_MY_BILLING_DATA + START });
  try {
    const result = await getAxiosInstance().put(
      `/api/persons/my/billing_info`,
      payload
    );
    dispatch({ type: UPDATE_MY_BILLING_DATA + DONE, payload: result.data });
    dispatch({ type: UPDATE_MY + DONE, payload: result.data });

    return result;
  } catch (payload) {
    dispatch({ type: UPDATE_MY_BILLING_DATA + FAILED, payload });
    return payload.response;
  }
};

export const updateMyAddressData = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_MY_ADDRESS_DATA + START });
  try {
    const result = await getAxiosInstance().put(
      `/api/persons/my/address`,
      payload
    );
    dispatch({ type: UPDATE_MY_ADDRESS_DATA + DONE, payload: result.data });
    dispatch({ type: UPDATE_MY + DONE, payload: result.data });

    return result;
  } catch (payload) {
    dispatch({ type: UPDATE_MY_ADDRESS_DATA + FAILED, payload });
    return payload.response;
  }
};
